define("settings/components/cancel-plan/slide/training-video", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <p class="tCA--title">{{@trainingVideo.title}}</p>
  <p class="u--m__b__lg">
    {{@trainingVideo.subCopy}}
  
    {{#if @trainingVideo.kb}}
      <Shared::Link
        class="u--inline"
        @href={{@trainingVideo.kb.link}}
        @text={{@trainingVideo.kb.text}}
      />
    {{/if}}
  </p>
  <Shared::WistiaVideo
    @paddingClass="--wistia__video_padding"
    @wrapperClass="--wistia__video_responsive_wrapper"
    @embedClass="--wistia__video_embed"
    @swatchClass="--wistia__video_swatch"
    @coverClass="--wistia__video_cover"
    @videoId={{@trainingVideo.videoId}}
    @swatchImageUrl={{@trainingVideo.imageUrl}}
  />
  
  */
  {
    "id": "0tYW4nQF",
    "block": "[[[10,2],[14,0,\"tCA--title\"],[12],[1,[30,1,[\"title\"]]],[13],[1,\"\\n\"],[10,2],[14,0,\"u--m__b__lg\"],[12],[1,\"\\n  \"],[1,[30,1,[\"subCopy\"]]],[1,\"\\n\\n\"],[41,[30,1,[\"kb\"]],[[[1,\"    \"],[8,[39,1],[[24,0,\"u--inline\"]],[[\"@href\",\"@text\"],[[30,1,[\"kb\",\"link\"]],[30,1,[\"kb\",\"text\"]]]],null],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"],[8,[39,2],null,[[\"@paddingClass\",\"@wrapperClass\",\"@embedClass\",\"@swatchClass\",\"@coverClass\",\"@videoId\",\"@swatchImageUrl\"],[\"--wistia__video_padding\",\"--wistia__video_responsive_wrapper\",\"--wistia__video_embed\",\"--wistia__video_swatch\",\"--wistia__video_cover\",[30,1,[\"videoId\"]],[30,1,[\"imageUrl\"]]]],null],[1,\"\\n\"]],[\"@trainingVideo\"],false,[\"if\",\"shared/link\",\"shared/wistia-video\"]]",
    "moduleName": "settings/components/cancel-plan/slide/training-video.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});